"use client";

import React, { ReactNode } from "react";
import { ArticleType } from "@motorata/base-ui.types.cms";
import TextWithImage from "@/components/shared/TextWithImage";
import FinanceHeader from "@/views/@static/finance/FinanceHeader";
import SeoTextSection from "@/components/sections/SeoTextSection";
import EducationSection from "@/components/sections/EducationSection";
import AdvantagesSection from "@/components/sections/AdvantagesSection";
import FooterSection from "@/components/shared/FooterSection";

export default function FinanceTemplate({ type, url, header, body, posts, title, content, children }: {
  type: "leasing" | "credit"
  url: string
  header: {
    title: ReactNode
    subtitle: string
    text: string
    list?: string[]
    image: string
  }
  body: {
    label: string
    title: string
    text?: string
    textHtml?: string
    list?: string[]
    image?: string
  }[]
  posts?: ArticleType[]
  title: string
  content?: string
  children?: ReactNode
}) {
  return (
    <>
      <FinanceHeader
        subtitle={header.subtitle}
        title={header.title}
        text={header.text}
        list={header.list}
        image={header.image}
      />
      {/*<FinanceBanner url={url} />*/}
      {
        body.map((el, index) =>
          <TextWithImage
            key={index}
            reverse={index % 2 !== 0}
            label={el.label}
            title={el.title}
            text={el.text}
            textHtml={el.textHtml}
            list={el.list}
            image={el.image}
          />
        )
      }
      <EducationSection />
      <FooterSection marginTop="0">
        <AdvantagesSection />
      </FooterSection>
      {/*<FinanceMotoUp type={type} />*/}
      {/*<ArticlesSection data={posts} />*/}
      <SeoTextSection title={title} content={content} />
      {children}
    </>
  )
}
